module.exports = __webpack_public_path__ + "media/Audio18_h.34f84d94.wav";